var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: { show: _vm.result_show }, attrs: { id: "result" } },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.Gold,
              expression: "Gold",
            },
          ],
          staticClass: "result_main",
          staticStyle: { cursor: "pointer" },
          on: { click: _vm.setGold },
        },
        [_vm._m(0), _vm._m(1)]
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.Gold,
              expression: "!Gold",
            },
          ],
          staticClass: "result_main",
        },
        [
          _c("div", { staticClass: "result_title" }, [
            _c("div", { staticClass: "title_main" }, [
              _c("p", [_vm._v(_vm._s(_vm.item_data.itemname))]),
              _c("i", { class: "rarity_" + _vm.item_data.rarity }),
            ]),
          ]),
          _c("div", { staticClass: "pic" }, [
            _c("img", { attrs: { src: _vm.item_data.itempic, alt: "" } }),
          ]),
          _c("div", { staticClass: "price" }, [
            _vm._v(_vm._s(_vm.item_data.price)),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "result_title" }, [
      _c("div", { staticClass: "title_main" }, [
        _c("p", [_vm._v("恭喜出金")]),
        _c("i", { staticStyle: { "background-color": "#ffd700" } }),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "pic turn" }, [
      _c("div", { staticClass: "Diga" }),
      _c("img", {
        staticStyle: { height: "380px" },
        attrs: {
          src: require("@/assets/images/official/gold_big_icon.png"),
          alt: "",
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }